import type { OneToTen, ScaleSelectorProps } from "@qendo/profile/journal";
import { OvulationMap, ScaleType } from "@qendo/trackables";
import { useEffect, useState } from "react";
import { FieldGroup } from "~/components/form/FieldGroup";
import { RangeInput } from "~/components/form/RangeInput";
import { RadioSelector } from "~/components/form/radio/RadioSelector";

const Yes = "Yes";
const No = "No";

export type OvulationSelectorProps = ScaleSelectorProps<ScaleType.ovulation>;

export const OvulationSelector = ({ label, value, onUpdateScale, disabled, error, zIndex }: OvulationSelectorProps) => {
    const [scale, setScale] = useState<number>(value.value ?? 0);
    const [mucus, setMucus] = useState<string>(value.mucus ? Yes : No);
    const [basal, setBasal] = useState<string>(value.basal ? Yes : No);
    const [breast, setBreast] = useState<string>(value.breast ? Yes : No);
    const [headache, setHeadache] = useState<string>(value.headache ? Yes : No);

    // biome-ignore lint/correctness/useExhaustiveDependencies(onUpdateScale): readonly
    useEffect(() => {
        onUpdateScale({
            type: ScaleType.ovulation,
            value: scale === 0 ? null : (Math.max(1, Math.min(10, scale)) as OneToTen),
            mucus: mucus === Yes,
            basal: basal === Yes,
            breast: breast === Yes,
            headache: headache === Yes,
        });
    }, [scale, mucus, basal, breast, headache]);

    return (
        <FieldGroup zIndex={zIndex}>
            <RangeInput
                label={label ?? "Intensity"}
                min={1}
                max={10}
                step={1}
                value={scale}
                onValueChange={setScale}
                disabled={disabled}
                error={error}
                optional
            />
            <RadioSelector
                title={`${OvulationMap.mucus}?`}
                options={["Yes", "No"]}
                columns={2}
                value={mucus}
                onValueChange={setMucus}
                disabled={disabled}
            />
            <RadioSelector
                title={`${OvulationMap.basal}?`}
                options={["Yes", "No"]}
                columns={2}
                value={basal}
                onValueChange={setBasal}
                disabled={disabled}
            />
            <RadioSelector
                title={`${OvulationMap.breast}?`}
                options={["Yes", "No"]}
                columns={2}
                value={breast}
                onValueChange={setBreast}
                disabled={disabled}
            />
            <RadioSelector
                title={`${OvulationMap.headache}?`}
                options={["Yes", "No"]}
                columns={2}
                value={headache}
                onValueChange={setHeadache}
                disabled={disabled}
            />
        </FieldGroup>
    );
};
